import { useCallback } from 'react';
import { useFormContext } from 'react-hook-form';
import { Radio } from '@alf/uikit';
import { maxLengthValidator, requiredValidator } from '@alf/validators';
import {
  Control,
  getFormError,
  InputField,
  useCustomError
} from '@namespace/forms';
import { useI18n } from '@namespace/i18n';

import styles from '../../index.module.css';

const SourceOfTheAssetsField = ({
  name,
  label = '',
  hint,
  elements = [],
  classNames = {},
  customError = ''
}) => {
  const {
    wrapperClassName = '',
    groupClassName = '',
    groupLabelClassName = '',
    customInputClassName = '',
    ...fieldClassNames
  } = classNames;
  const { t } = useI18n();
  const {
    formState: { errors },
    watch,
    setValue,
    trigger
  } = useFormContext();
  const { errorMessage, customErrorHandler } = useCustomError(customError);
  const customInputName = watch('customInputName');
  const onCustomClick = useCallback(
    (e) => {
      e.stopPropagation();
      // useRef does not work in this case. Used dom instead for focus
      document.getElementsByName('customInputName')[0].focus();
      setValue('customInputName', customInputName.trim());
      document.querySelector('#radio-custom').checked = true;
    },
    [setValue, customInputName]
  );
  const onCustomBlur = useCallback(async () => {
    setValue('customInputName', ' ');
    await trigger('customInputName');
  }, [setValue]);

  const customVariant = (
    <InputField
      name="customInputName"
      rules={{
        ...requiredValidator(),
        ...maxLengthValidator(150)
      }}
      classNames={{ inputClassName: customInputClassName }}
    />
  );

  return (
    <Control
      error={getFormError(name, errors, t) || t(errorMessage)}
      onClick={customErrorHandler}
      hint={hint}
      classNames={{ className: wrapperClassName }}
    >
      {label && <span className={groupLabelClassName}>{t(label)}</span>}
      <div className={groupClassName}>
        {elements.map(
          ({ label: radioLabel, value, disabled = false, ...rest }) => {
            return (
              <Radio
                key={`radio-${value}`}
                onClick={onCustomBlur}
                name={name}
                label={t(radioLabel)}
                value={value}
                disabled={disabled}
                {...rest}
                {...fieldClassNames}
              />
            );
          }
        )}
        <div onClick={onCustomClick}>
          <Radio
            id="radio-custom"
            key="radio-custom"
            name={name}
            label={customVariant}
            value={customInputName}
            {...fieldClassNames}
            classNames={{
              labelTextClassName: styles.radioInputLabelText
            }}
          />
        </div>
      </div>
    </Control>
  );
};

export default SourceOfTheAssetsField;
